import { Component, inject, signal } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import {  MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';
import { RouterLink, RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { PrincipalHeader } from "../principal-header/principal-header";
import { AuthService } from '../../services/auth-service';
import { SpinnerService } from '../../services/spinner-service';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChatbotToggleComponent } from "../../features/chatbot/chatbot-toggle/chatbot-toggle";
import { LangTranslator } from '../translator/langtranslator';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatorPipe } from '../translator/translator-pipe';

@Component({
  selector: 'app-home',
  imports: [
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    RouterLink,
    RouterOutlet,
    AsyncPipe,
    PrincipalHeader,
    MatProgressSpinnerModule,
    ChatbotToggleComponent,
    MatMenuModule,
    TranslatorPipe
],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {
  private router = inject(Router);
  private spinnerService = inject(SpinnerService);
  public readonly langService = inject(LangTranslator);
  public authService = inject(AuthService);
  loading$ = this.spinnerService.loading$;
  sidenavOpened = signal(true);
  currentScreen = signal('Home');

  constructor() {
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        const seg = evt.urlAfterRedirects.split('/').filter(Boolean)[0] || '';
        const titles: Record<string,string> = {
          vessels: 'Flota',
          login: 'Login',
          engines: 'Motores',
        };
        this.currentScreen.set(titles[seg] ?? 'Home');
      }
    });
  }

  get title() {
    return this.currentScreen();
  }

  openSidenav() {
    this.sidenavOpened.set(true);
  }
  closeSidenav() {
    this.sidenavOpened.set(false);
  }
  toggleSidenav() {
    this.sidenavOpened.update(opened => !opened);
  }
  logout() {    
    this.authService.logout(this.authService.userSignal()._id).subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: (err) => {
        console.error('Logout error', err);
        this.router.navigate(['/login']);
      }
    });
  }
}
